const searchEngines = [
  "google",
  "bing",
  "yahoo",
  "baidu",
  "yandex",
  "duckduckgo",
  "ask",
  "ecosia",
  "aol",
  "archive",
];

const createStore = () => {
  const _data = {
    utm_source: undefined,
    utm_campaign: undefined,
    utm_content: undefined,
    utm_medium: undefined,
    utm_term: undefined,
    ad_id: undefined,
    cp_smn_content: undefined,
    cp_smn_term: undefined,
    cp_smn_source: undefined,
    fbclid: undefined,
  };

  const unserialize = (content) => {
    try {
      const data = JSON.parse(content);
      for (const key in data) {
        if (_data.hasOwnProperty(key) && 0 !== data[key].toString().length) {
          _data[key] = data[key].toString();
        }
      }
      return;
    } catch (e) {
      throw Error("Store is malformed");
    }
  };

  return {
    get: (key) => {
      if (_data.hasOwnProperty(key)) {
        return _data[key];
      }
      return undefined;
    },
    update: (key, value) => {
      if (!_data.hasOwnProperty(key)) {
        return;
      }
      _data[key] = value;
    },
    getAll: () => {
      return _data;
    },
    delete: (key) => {
      if (!_data.hasOwnProperty(key)) {
        return;
      }
      _data[key] = undefined;
    },
    unserialize,
  };
};

const store = createStore();

const updateSessionStorage = (value) => {
  window.sessionStorage.setItem("utm_storage", JSON.stringify(value));
};

const readSessionStorage = () => {
  const data = window.sessionStorage.getItem("utm_storage");
  if (typeof data === "string") {
    return data;
  }
};

const updateUTMParamsFromReferer = () => {
  if (store.get("utm_source") !== undefined) {
    return;
  }
  if (document.referrer.length === 0) {
    store.update("utm_source", "direct");
    return;
  }
  if (document.referrer.includes("com.google.android.googlequicksearchbox")) {
    store.update("utm_source", "discover");
    store.update("utm_medium", "referral");
  } else {
    const isOrganic = searchEngines.some((searchEngine) => {
      return document.referrer.includes(searchEngine);
    });
    if (isOrganic.length !== 0) {
      const source = isOrganic
        .map((source) => {
          if (source.includes("naver")) {
            return "naver";
          }
          return source;
        })
        .pop();
      store.update("utm_medium", "organic");
      store.update("utm_source", source);
    } else {
      try {
        const urlDetails = parse(document.referrer);
        store.update("utm_source", urlDetails.domainWithoutSuffix);
        store.update("utm_medium", "referral");
      } catch (e) {
        store.update("utm_source", "direct");
        store.delete("utm_medium");
      }
    }
  }
};

const getURLParameters = (url) =>
  (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
    (a, v) => (
      (a[v.slice(0, v.indexOf("="))] = v.slice(v.indexOf("=") + 1)), a
    ),
    {}
  );

const storeSessionUTMParams = () => {
  if (window.sessionStorage["utm_storage"]) {
    const data = readSessionStorage();
    store.unserialize(data);
  } else {
    const { search } = window.location;
    const sessionUtms = getURLParameters(search);
    for (const key in sessionUtms) {
      store.update(key, sessionUtms[key]);
      updateSessionStorage(store.getAll());
    }
  }
  updateUTMParamsFromReferer();
};

function getInnerUtmValues(link) {
  if (link && link.dataset) {
    return {
      cp_landing_term: link.dataset.gaAction,
      cp_landing: link.dataset.gaAction,
      cp_landing_source: link.dataset.utmSource,
    };
  }
}

function applyUtmsToUrl(url, utms) {
  for (let key in utms) {
    if (utms[key] === undefined) {
      continue;
    }
    if (utms[key] === "_target") {
      continue;
    }
    url.searchParams.set(key, utms[key]);
  }
}

const processLinks = () => {
  const links = document.querySelectorAll("[data-utms]");
  if (links.length > 0) {
    for (const link of links) {
      link.addEventListener("click", (e) => {
        const target = e.target;
        const innerUtms = getInnerUtmValues(link);
        const utmParams = store.getAll();
        const url = new URL(target.href);

        const queryExists = target.href.indexOf("?");

        if (queryExists) {
          let query = queryExists
            ? target.href.substring(queryExists + 1)
            : null;
          applyUtmsToUrl(url, getURLParameters(query));
        }

        applyUtmsToUrl(url, utmParams);
        applyUtmsToUrl(url, innerUtms);

        window.open(url.toString(), "_blank");
      });
    }
  }
};

function initUTM() {
  storeSessionUTMParams();
  processLinks();
}

initUTM();
